/**
 * Helpers for clinic messaging toggles (thank-you / follow-up).
 */
export const isClinicSettingYes = (code: string): boolean => {
  try {
    const raw = window.localStorage.getItem("user");
    if (!raw) return false;
    const user = JSON.parse(raw);
    const config = user?.activeClinic?.configuration?.find(
      (item: any) => item.code === code
    );
    return config?.value === "yes";
  } catch {
    return false;
  }
};

export const isSendThankYouMessageEnabled = (): boolean =>
  isClinicSettingYes("send_thank_you_message");

export const isSendFollowUpMessageEnabled = (): boolean =>
  isClinicSettingYes("send_follow_up_message");
